/**
 * ADMIN CATEGORY SEEDS (ДОВІДНИК ДЛЯ АДМІНКИ)
 * ------------------------------------------------------------
 * Цей файл містить "еталонні" (узгоджені) назви категорій, які
 * адміністратор має створити в адмін-панелі. (При створенні категорій в адмінці назви категорій можна записувати з великої букви)
 *
 * Навіщо це потрібно:
 * - в різних проектах використовується одна й та сама логіка
 * - можна швидко підглянути, як саме треба назвати категорії
 * - код на фронтенді шукає категорію по slug або name
 *
 * ВАЖЛИВО:
 * - Якщо в адмінці змінюється name або slug — потрібно змінити тут.
 * - Для дочірніх категорій (новинки/популярні/акції) parentSlug
 *   має вказувати на slug батьківської ("пропозиції").
 */

export const ADMIN_CATEGORY_SEEDS = {
   OFFERS: {
      name: "пропозиції",
      slug: "propoziciyi",
   },

   CHILDREN: {
      NEW: {
         name: "новинки",
         slug: "novinki",
         parentSlug: "propoziciyi",
      },
      POPULAR: {
         name: "популярні товари",
         slug: "populyarnitovari",
         parentSlug: "propoziciyi",
      },
      SALES: {
         name: "акційні пропозиції",
         slug: "akciyni-propoziciyi",
         parentSlug: "propoziciyi",
      },
   },
};

/**
 * Допоміжні константи.
 */
export const CATEGORY_OFFERS_SLUG = ADMIN_CATEGORY_SEEDS.OFFERS.slug;
export const CATEGORY_NEW_SLUG = ADMIN_CATEGORY_SEEDS.CHILDREN.NEW.slug;
export const CATEGORY_POPULAR_SLUG = ADMIN_CATEGORY_SEEDS.CHILDREN.POPULAR.slug;
export const CATEGORY_SALES_SLUG = ADMIN_CATEGORY_SEEDS.CHILDREN.SALES.slug;

/**
 * Нормалізація для порівняння slug/name.
 */
const normalize = (v) =>
   String(v ?? "")
      .trim()
      .toLowerCase();


/**
 * Повертає "seed" категорії, якщо знайдено співпадіння по slug або name.
 * Якщо не знайдено — повертає null.
 *
 * @param {string} value slug або name
 * @returns {object|null}
 */
export const findAdminCategorySeed = (value) => {
   const v = normalize(value);
   if (!v) return null;

   const flat = [
      ADMIN_CATEGORY_SEEDS.OFFERS,
      ...Object.values(ADMIN_CATEGORY_SEEDS.CHILDREN),
   ];

   return (
      flat.find((c) => normalize(c.slug) === v || normalize(c.name) === v) ?? null
   );
};